import { AbstractCodeValue } from "./abstractCodeValue";

export class ConfCodeValue extends AbstractCodeValue {
    
  
}